import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=f86f463a&scoped=true&"
import script from "./messageDetail.vue?vue&type=script&lang=js&"
export * from "./messageDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=f86f463a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f463a",
  null
  
)

export default component.exports